module.exports = __webpack_public_path__ + "static/img/immark.1fb6464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/immark.png
// module id = 488
// module chunks = 1